import { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";

const statusArray = [
    { name: "Available", class: "available" },
    { name: "Busy", class: "busy" },
    { name: "Out of Office", class: "out" },
    { name: "On Vacation", class: "vacation" }
];

const UserStatusDropDown = ({ currentVal, onStatusChange, className }) => {
    const [value, setValue] = useState(currentVal);

    const handleChange = (newStatus) => {
        setValue(newStatus);
        onStatusChange(newStatus);
    };

    useEffect(() => {
        setValue(currentVal);
    }, [currentVal]);

    // Determine displayed text & class
    const selectedStatus = value ? statusArray[value - 1] : null;

    return (
        <Dropdown className={`user-status-dropdown${className ? ` ${className}` : ''}`}>
            <Dropdown.Toggle variant="none" align="end">

                {/* If null → show empty UI */}
                {selectedStatus ? (
                    <>
                        <span className={`status ${selectedStatus.class}`}></span>
                        {selectedStatus.name}
                    </>
                ) : (
                    <span className="text-muted">Select Status</span> // placeholder
                )}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {statusArray.map((status, index) => (
                    <Dropdown.Item 
                        key={index} 
                        onClick={() => handleChange(index + 1)}
                    >
                        <span className={`status ${status.class}`}></span> 
                        {status.name}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default UserStatusDropDown;
